import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { matchingToValidator } from '@cakeiteasy/web-utils';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { UserManager } from '../../../users/services/user.manager';
import { IUser } from '../../../users/models/i-user';

@Component({
  standalone: false,
  selector: 'reset-password-form',
  templateUrl: './reset-password-form.component.html',
  styleUrls: ['./reset-password-form.component.scss']
})
export class ResetPasswordFormComponent implements OnInit {
  @Input() user: IUser;
  @Output() onResetPassword = new EventEmitter<any>();

  public resetPasswordForm: FormGroup;
  public updatePasswordError: string;

  constructor(private _fb: FormBuilder,
              private _translate: TranslateService,
              private _toastr: ToastrService,
              private _users: UserManager) {
  }

  ngOnInit() {
    this.resetPasswordForm = this._fb.group({
      oldPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
    }, {
      validator: matchingToValidator('confirmPassword', 'newPassword')
    });
  }

  public changePassword() {
    this.updatePasswordError = '';

    this._users.resetPassword(this.resetPasswordForm.value)
      .then(() => {
        this.resetPasswordForm.reset({});
        const message = this._translate.instant('profile.changePassword.passwordChanged');
        const title = this._translate.instant('common.success');
        this._toastr.success(message, title);
      })
      .catch((err) => {
        if (err.status === 400) {
          this.updatePasswordError = this._translate.instant('profile.changePassword.oldPasswordIsIncorrect');
        } else {
          this.updatePasswordError = 'Unexpected error';
        }
      });
  }
}
